import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlendersService {

  constructor(
    private http: HttpClient
  ) { }

  getBlenders() {
    return (this.http.get(`${environment.apiUrl}/blenders`));
  }

  createBlender(blender: any) {
    return (this.http.post(`${environment.apiUrl}/blenders`, blender));
  }
  
  getBlenderById(id: number) {
    return(this.http.get(`${environment.apiUrl}/blenders/${id}`));
  }
  
  updateBlender(blender: any) {
    return (this.http.put(`${environment.apiUrl}/blenders/${blender.id}`, blender));
  }


  deleteBlender(id: number) {
    return(this.http.delete(`${environment.apiUrl}/blenders/${id}`));
  }
}
